import { call, put, takeEvery } from "redux-saga/effects";

import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";
import { fetchMe, clearProfile } from "../profile/actions";

import { postJwtLogin, postLogout } from "../../../helpers/fakebackend_helper";
import { setSessionToken, clearSessionToken } from "../../../helpers/jwt-token-access/sessionToken";

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(postJwtLogin, {
      email: user.email,
      password: user.password,
      rememberMe: !!user.rememberMe,
    });
    // DASH-024: the backend also set an httpOnly auth cookie. Keep the token in
    // memory only (XSS can't read a cookie OR exfiltrate a non-persisted token)
    // and persist everything EXCEPT the token, with a `session` marker so the
    // app knows to restore via /auth/me (cookie) on the next load.
    const { accessToken, ...persistable } = response || {};
    setSessionToken(accessToken);
    localStorage.setItem("authUser", JSON.stringify({ ...persistable, session: true }));
    yield put(loginSuccess(response));
    yield put(fetchMe());
    if (history) history.push("/overview");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser() {
  try {
    try { yield call(postLogout); } catch (_) { /* network errors are fine on logout */ }
    clearSessionToken();
    localStorage.removeItem("authUser");
    yield put(clearProfile());
    yield put(logoutUserSuccess(LOGOUT_USER, true));
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
